module.exports = __webpack_public_path__ + "static/media/select_balancei.19a400f9.png";